import { IoMdDownload } from "react-icons/io";
import { toast } from "react-toastify";
import TableComponent from "../../../Comman/TableComponent";
import Pagination from "../../../Comman/Pagination";
import { useEffect, useState } from "react";
import { ProjectService } from "../../../../services/ProjectService";
import { useParams } from "react-router-dom";
import { useSearch } from "../../../../context/SearchContext";
import { RiDeleteBin6Line } from "react-icons/ri";
import DocumentTypeFilter from "../../../Comman/DocumentTypeFilter";
import { usePagination } from "../../../../hooks/usePagination";
import { Button } from "@headlessui/react";
import MobAdminEmpOldDocument from "./MobAdminEmpOldDocument";


export default function AdminEmpOldDocument() {
  const { id } = useParams();
  const { debounceSearchTerm } = useSearch();
  const [refresh, setRefresh] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [docType, setDocType] = useState("");
  const { currentPage, totalPages, goToPage, setTotalPages } = usePagination();
  const fixedDate = process.env.REACT_APP_FIXED_DATE;

  const handleDownloadClick = async (doc) => {
    try {
      const response = await ProjectService.viewDocumentById(doc.id);

      if (response && response.data && response.type) {
        const mimeType = response.type;

        const extensionMap = {
          "application/pdf": "pdf",
          "image/png": "png",
          "image/jpeg": "jpg",
          "image/jpg": "jpg",
          "image/webp": "webp",
          "application/zip": "zip",
          "application/x-zip-compressed": "zip",
          "application/msword": "doc",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
          "application/vnd.ms-excel": "xls",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
          "text/plain": "txt",
          "application/json": "json",
          "application/octet-stream": "bin",
        };

        const extension = extensionMap[mimeType] || "file";

        const base64Data = response.data.split(",")[1];
        const byteCharacters = atob(base64Data);
        const byteNumbers = Array.from(byteCharacters, (c) => c.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);

        const blob = new Blob([byteArray], { type: mimeType });
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = `${doc.documentName}.${extension}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        URL.revokeObjectURL(url);
      }
    } catch (error) {
      toast.error(error?.message || "Download failed");
    }
  };

  const handleDelete = async (id) => {
    try {
      const result = await ProjectService.deleteDocument(id);
      if (result) {
        toast.success("Document deleted successfully");
        setDocuments((prev) => prev.filter((item) => item.id !== id));
      }
    } catch (error) {
      toast.error(error.message || "Failed to delete document");
    }
  };

  const handleToggleAction = async (documentId, isPublished) => {
    try {
      const value = isPublished ? "Unpublished" : "Published";
      const response = await ProjectService.publishedProjectDocument(documentId);
      if (response) {
        toast.success(`Project final document ${value} successfully`);
        setRefresh((prev) => !prev);
      }
    } catch (error) {
      toast.error(error?.message);
    }
  };

  const columns = [
    {
      label: "Document Name",
      field: "documentName",
      headerClassName:
        "text-left pl-2 border-l border-t border-b border-[#d3cccc] whitespace-nowrap",
      className:
        "text-[15px] text-left pl-2 border-l border-[#d3cccc]",
    },
    {
      label: "File Name",
      field: "fileName",
      headerClassName:
        "text-left pl-2 border-t border-b border-[#d3cccc] whitespace-nowrap",
      className:
        "text-[15px] text-left pl-2 border-[#d3cccc] break-all",
    },
    {
      label: "Doc Type",
      field: "documentType",
      headerClassName:
        "text-left pl-2 border-t border-b border-[#d3cccc] whitespace-nowrap",
      className:
        "text-[15px] text-left pl-2 border-[#d3cccc] capitalize",
    },
    {
      label: "Date",
      field: "uploadDate",
      headerClassName:
        "text-left pl-2 border-t border-b border-[#d3cccc] whitespace-nowrap",
      className:
        "text-[15px] text-left pl-2 border-[#d3cccc]",
    },
    {
      label: "Uploaded By",
      field: "uploadBy",
      headerClassName:
        "text-left pl-2 border-t border-b border-[#d3cccc] whitespace-nowrap",
      className:
        "text-[15px] text-left pl-2 border-[#d3cccc]",
    },
    {
      label: "Publish",
      headerClassName:
        "text-center border-t border-b border-[#d3cccc] whitespace-nowrap",
      className: "text-[15px] text-center w-[10%]",
      render: (project) => (
        <Button
          onClick={() =>
            handleToggleAction(project?.id, project?.isPublished)
          }
          className={`!w-24 !capitalize !font-medium ${
            !project?.isPublished
              ? "!text-red-600 border rounded-sm !border-red-400 hover:!bg-red-500 hover:!text-white"
              : "!text-green-600 border rounded-sm !border-green-400 hover:!bg-green-500 hover:!text-white"
          }`}
        >
          {project?.isPublished ? "Unpublish" : "Publish"}
        </Button>
      ),
    },
    {
      label: "Download",
      headerClassName:
        "border-t border-b border-[#d3cccc] text-center whitespace-nowrap",
      className: "border-[#d3cccc]",
      render: (doc) => (
        <IoMdDownload
          className="text-blue-600 text-xl cursor-pointer mx-auto"
          onClick={() => handleDownloadClick(doc)}
        />
      ),
    },
    {
      label: "Action",
      headerClassName:
        "border-r border-t border-b border-[#d3cccc] whitespace-nowrap",
      className:
        "text-[15px] border-r border-[#d3cccc] w-[10%]",
      render: (item) => (
        <div className="flex justify-center items-center">
          <RiDeleteBin6Line
            onClick={() => handleDelete(item.id)}
            size={18}
            className="text-red-600 cursor-pointer"
          />
        </div>
      ),
    },
  ];

  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const response = await ProjectService.getProjectDocuments(
          id,
          0,
          0,
          "MRR",
          currentPage,
          10,
          debounceSearchTerm,
          docType,
          fixedDate
        );
        if (response) {
          setDocuments(response?.data);
          setTotalPages(response?.pagination?.totalPages);
        }
      } catch (error) {
        toast.error(error?.message);
      }
    };
    fetchDocuments();
  }, [debounceSearchTerm, id, currentPage, docType, refresh, fixedDate, setTotalPages]);

return (
  <section className="p-4 sm:p-5">
    <div className="px-4 sm:px-6 py-2">
      <div className="flex justify-end items-center mb-3">
        <DocumentTypeFilter docType={docType} setDocType={setDocType} />
      </div>

      {/* ================= MOBILE ================= */}
      <div className="md:hidden">
        <MobAdminEmpOldDocument
          documents={documents}
          onDownload={handleDownloadClick}
          onDelete={handleDelete}
          onTogglePublish={handleToggleAction}
        />
      </div>

      {/* ================= DESKTOP ================= */}
      <div className="hidden md:block w-full overflow-x-auto">
        <div className="min-w-[1100px]">
          <TableComponent
            columns={columns}
            data={documents}
            headerBg="bg-[#f6f6f6]"
          />
        </div>
      </div>

      <br />

      {documents.length > 0 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          goToPage={goToPage}
        />
      )}
    </div>
  </section>
);

}
